module.exports = __webpack_public_path__ + "img/IMG_8618_L_WoodMatted.cc50472c.jpg";